import { compose, prop } from 'ramda';

const coupon = compose(Boolean, prop('can_redeem'));

export { coupon };
